import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.dianaia.online/api';

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    const orgId = localStorage.getItem('org-id');
    const token = localStorage.getItem('auth-token');

    if (orgId) {
        config.headers['x-organization-id'] = orgId;
    }

    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url: string = error.config?.url || '';
            const errMsg: string = error.response?.data?.error || '';

            // Solo cerrar sesión si el token realmente es inválido o expirado.
            // No cerrar sesión por errores de negocio (orgId faltante, permisos, etc.)
            const isTokenError =
                errMsg === 'Invalid token' ||
                errMsg === 'No token provided' ||
                url.includes('/auth/me');

            if (isTokenError) {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('org-id');
                localStorage.removeItem('user-data');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
